import { createFileRoute } from "@tanstack/react-router";
import { CITY_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/phoenix-ppc-agency")({
  head: () => localPageHead(CITY_PAGES.phoenix!),
  component: PhoenixPage,
});

function PhoenixPage() {
  return <LocalPageView page={CITY_PAGES.phoenix!} />;
}
